import type { DetailType, InsuranceRateType } from "~/types";

export const getInsuranceDetails = (value: InsuranceRateType): DetailType[] => [
  { title: 'Tipologia', label: value.subCategory || '' },

]